import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { getKwpAccessToken } from 'src/pages/settings/components/interfaces/kwp/components/helpers';

export const useFetchKwpData = (userLink: string, fetchLink: string) => {
  const { t } = useTranslation(['common', 'customers']);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState<any>([]);

  const token = getKwpAccessToken();
  const url = `${userLink}/api${fetchLink}=`;
  const headers = {
    accept: 'text/plain',
    'x-kwp-version': '1',
    Authorization: `Bearer ${token}`,
  };

  const fetchData = (dataArray: string[], isCustomersModal: boolean) => {
    const uniqKey = isCustomersModal ? 'adrNrGes' : 'projNr';

    if (userLink && dataArray.length > 0) {
      setLoading(true);
      dataArray.forEach((record: string) =>
        axios
          .get(url + record, { headers })
          .then(({ data: responseData }) => {
            if (responseData) {
              setData((prev: any) => {
                const uniqueAdrNrGes = new Set(prev.map((item: any) => item[uniqKey]));
                if (!uniqueAdrNrGes.has(responseData[uniqKey])) {
                  const updatedData = [...prev, responseData];
                  uniqueAdrNrGes.clear();
                  uniqueAdrNrGes.add(responseData[uniqKey]);
                  if (dataArray.length === 1) {
                    uniqueAdrNrGes.delete(prev[uniqKey]);
                    return [responseData];
                  }
                  return updatedData;
                } else if (uniqueAdrNrGes.has(responseData[uniqKey])) {
                  uniqueAdrNrGes.delete(responseData[uniqKey]);
                  return [responseData];
                } else if (!dataArray.length) {
                  uniqueAdrNrGes.clear();
                  return [];
                }
              });
            }
          })
          .catch(err => {
            if (err.response.status === 404) {
              console.warn('Customer not found');
            } else if (err.response.status === 401) {
              showNotification({
                type: NOTIFICATION_TYPE.warning,
                message: t('common:labels.notValidToken'),
              });
            }
          })
          .finally(() => setLoading(false))
      );
    }
  };

  return { data, loading, fetchData };
};
